import React from 'react';

import { c } from 'ttag';

import {
    Sidebar as AppSidebar,
    AuthenticationStore,
    SidebarAccount,
    SidebarList,
    SidebarListItem,
    SidebarNav,
    useAuthentication,
    useCurrentUser,
} from '@freelancelabs/components';
import { ArrowLeft, LogoutOutline } from '@freelancelabs/icons';

import { useReturnTarget } from '../returnTarget';

// No return link to the product: `account` does not know which app the person came from
// (the entry links are bare and `redirect-after-login` is consumed on the first hop).
const Sidebar = () => {
    const { logout } = useAuthentication() as AuthenticationStore;
    const back = useReturnTarget();
    const { email, firstName, lastName } = useCurrentUser();

    const displayName = [firstName, lastName].filter(Boolean).join(' ') || email || '';

    return (
        <AppSidebar
            variant="portal"
            footer={
                <SidebarAccount name={displayName}>
                    <a
                        href="#logout"
                        className="sidebar-account__logout"
                        onClick={(event) => {
                            event.preventDefault();
                            void logout();
                        }}
                    >
                        <LogoutOutline />
                        {c('Account sidebar').t`Logout`}
                    </a>
                </SidebarAccount>
            }
        >
            <SidebarNav>
                <SidebarList>
                    {/* A cross-origin `to` makes SidebarListItem's Link do a full-page navigation. */}
                    <SidebarListItem title={back.label} icon={<ArrowLeft size={16} />} to={back.href} />
                </SidebarList>
            </SidebarNav>
        </AppSidebar>
    );
};

export default Sidebar;
